import { getSuperAdminHeaders } from "./authService.js";

const domain = process.env.REACT_APP_DOMAIN;

export async function fetchDashboard() {
  const res = await fetch(`${domain}/api/v1/super-admin/dashboard`, {
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to fetch dashboard");
  return data;
}

export async function fetchUsers({ page = 1, limit = 20, search = "", role = "", status = "" } = {}) {
  const params = new URLSearchParams({ page, limit, search, role, status });
  const res = await fetch(`${domain}/api/v1/super-admin/users?${params}`, {
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to fetch users");
  return data;
}

export async function suspendUser(userId) {
  const res = await fetch(`${domain}/api/v1/super-admin/users/${userId}/suspend`, {
    method: "PUT",
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed");
  return data;
}

export async function activateUser(userId) {
  const res = await fetch(`${domain}/api/v1/super-admin/users/${userId}/activate`, {
    method: "PUT",
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed");
  return data;
}

export async function terminateUser(userId) {
  const res = await fetch(`${domain}/api/v1/super-admin/users/${userId}/terminate`, {
    method: "DELETE",
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed");
  return data;
}

export async function fetchCompanies({ page = 1, limit = 20, search = "" } = {}) {
  const params = new URLSearchParams({ page, limit, search });
  const res = await fetch(`${domain}/api/v1/super-admin/companies?${params}`, {
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to fetch companies");
  return data;
}

export async function fetchActivityLogs({ page = 1, limit = 30, event_type = "", user_id = "", user_search = "", date_from = "", date_to = "" } = {}) {
  const params = new URLSearchParams({ page, limit, event_type, user_id, user_search, date_from, date_to });
  const res = await fetch(`${domain}/api/v1/super-admin/activity-logs?${params}`, {
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to fetch logs");
  return data;
}

export async function deleteCompany(companyId) {
  const res = await fetch(`${domain}/api/v1/super-admin/companies/${companyId}`, {
    method: "DELETE",
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to delete company");
  return data;
}

export async function fetchTrash({ page = 1, limit = 20, search = "", type = "" } = {}) {
  const params = new URLSearchParams({ page, limit, search, type });
  const res = await fetch(`${domain}/api/v1/super-admin/trash?${params}`, {
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to fetch trash");
  return data;
}

export async function restoreCompany(companyId) {
  const res = await fetch(`${domain}/api/v1/super-admin/trash/restore-company/${companyId}`, {
    method: "PUT",
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to restore");
  return data;
}

export async function permanentDeleteCompany(companyId) {
  const res = await fetch(`${domain}/api/v1/super-admin/trash/permanent-delete/${companyId}`, {
    method: "DELETE",
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed");
  return data;
}

export async function fetchIndustryTemplatesAdmin() {
  const res = await fetch(`${domain}/api/v1/super-admin/industry-templates`, {
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed");
  return data;
}

export async function createIndustryTemplate({ key, label, fields }) {
  const res = await fetch(`${domain}/api/v1/super-admin/industry-templates`, {
    method: "POST",
    headers: { ...getSuperAdminHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ key, label, fields }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed");
  return data;
}

export async function updateIndustryTemplate(key, { label, fields }) {
  const res = await fetch(`${domain}/api/v1/super-admin/industry-templates/${key}`, {
    method: "PUT",
    headers: { ...getSuperAdminHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ label, fields }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed");
  return data;
}

export async function deleteIndustryTemplate(key) {
  const res = await fetch(`${domain}/api/v1/super-admin/industry-templates/${key}`, {
    method: "DELETE",
    headers: getSuperAdminHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed");
  return data;
}
